import React from 'react';
import { CreditCard, Check } from 'lucide-react';

const Pricing = () => {
  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-4xl mx-auto px-6 text-center mb-12">
        <h2 className="text-3xl font-bold text-slate-900 mb-6">Why Enrollment Is Paid</h2>
        <p className="text-lg text-slate-600">
          InternStacks operates on a structured participation model. We prioritize sustainable infrastructure over volume.
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch">
        <div className="bg-white p-10 border border-slate-200 rounded-sm shadow-sm flex flex-col">
          <h3 className="text-xl font-bold text-slate-900 mb-6 flex items-center">
            <CreditCard className="w-5 h-5 mr-3 text-slate-500" />
            Funding Allocation
          </h3>
          <p className="text-slate-600 mb-6">Enrollment fees directly support:</p>
          <ul className="space-y-4 flex-1">
            {[
              "Dedicated mentorship hours",
              "Project governance infrastructure",
              "Review and evaluation processes",
              "Technical oversight",
              "Administrative and compliance management"
            ].map((item, i) => (
              <li key={i} className="flex items-start text-slate-700">
                <Check className="w-5 h-5 text-emerald-500 mr-3 shrink-0" />
                {item}
              </li>
            ))}
          </ul>
        </div>

        <div className="bg-slate-100 p-10 border border-slate-200 rounded-sm flex flex-col justify-center items-center text-center">
          <h3 className="text-2xl font-bold text-slate-900 mb-4">Important Disclosure</h3>
          <p className="text-slate-600 mb-8 max-w-md">
            Payment secures structured participation within a governed system. It <strong className="text-slate-900">does not</strong> guarantee employment.
          </p>
          <div className="text-sm text-slate-500 border-t border-slate-300 pt-6 w-full">
            We value transparency. The fee is a participation cost for the ecosystem, not a purchase of a job offer.
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
